export enum DateFormat {
	DD_MM_YYYY_SLASH = 'DD/MM/YYYY'
}